"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClassesFacetNav = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const tree_navigation_1 = require("../../tree-navigation");
const nodes_tree_context_1 = require("../../../contexts/nodes-tree.context");
const store_1 = require("../../../../store");
const utils_1 = require("../../../../utils");
const TaxonomyClassesFacetNav = ({ expandOverride, debouncedSearchTerm, isSimple, }) => {
    const includedTaxonomyClassesIds = (0, store_1.useProductsIncludedTaxonomyClassIds)();
    const excludedTaxonomyClassesIds = (0, store_1.useProductsExcludedTaxonomyClassIds)();
    const { inUseTerminalNodes } = (0, store_1.useClassesSelector)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleSetInclude = (0, react_1.useCallback)((selectedId) => dispatch((0, store_1.productsSetIncludedTaxonomyClassIds)(selectedId)), [dispatch]);
    const handleSetExclude = (0, react_1.useCallback)((selectedId) => dispatch((0, store_1.productsSetExcludedTaxonomyClassIds)(selectedId)), [dispatch]);
    const { nodesTree } = (0, react_1.useContext)(nodes_tree_context_1.NodesTreeContext);
    const parentIds = (0, react_1.useMemo)(() => (0, utils_1.getNodesWithChildren)(nodesTree), [nodesTree]);
    const simpleFacetNavData = (0, react_1.useMemo)(() => inUseTerminalNodes.reduce((map, taxonomyClass) => {
        map.set(taxonomyClass.id, Object.assign(Object.assign({}, taxonomyClass), { parentId: null, children: new Map() }));
        return map;
    }, new Map()), [inUseTerminalNodes]);
    const commonProps = {
        excluded: excludedTaxonomyClassesIds,
        included: includedTaxonomyClassesIds,
        expandOverride,
        setExcluded: handleSetExclude,
        setIncluded: handleSetInclude,
        debouncedSearchTerm,
    };
    return isSimple ? (react_1.default.createElement(tree_navigation_1.TreeNavigation, Object.assign(Object.assign({}, commonProps), { treeData: simpleFacetNavData, parentIds: [] }))) : (react_1.default.createElement(tree_navigation_1.TreeNavigation, Object.assign(Object.assign({}, commonProps), { treeData: nodesTree, parentIds: parentIds, terminalNodeInteractionOnly: true })));
};
exports.TaxonomyClassesFacetNav = TaxonomyClassesFacetNav;
exports.default = exports.TaxonomyClassesFacetNav;
